export const QUERY_PARAM_IMPORT_TYPE = 'importType';

export const IMPORT_TYPE_CSV = 'importCsv';
export const IMPORT_TYPE_INVITATION = 'invitation';
export const IMPORT_TYPE_OFFLINE_SALE = 'offlineSale';
export const IMPORT_TYPE_PASS_HOLDER = 'passHolder';
